import { createI18n } from "vue-i18n";
import ru from "./locales/ru.json"
import en from "./locales/en.json"
import de from "./locales/de.json"
import es from "./locales/es.json"
import fr from "./locales/fr.json"
import it from "./locales/it.json"
import pl from "./locales/pl.json"
import pt from "./locales/pt.json"
import tr from "./locales/tr.json"
import ko from "./locales/ko.json"
import sv from "./locales/sv.json"
import hi from "./locales/hi.json"
import bn from "./locales/bn.json"
import sw from "./locales/sw.json"

export default createI18n({
    locale: localStorage.getItem('lang') || 'ru', // en
    fallbackLocale: 'ru', 
    legacy: false,
    globalInjection: true,
    messages: { 
        ru,
        en,
        de,
        es,
        fr,
        it,
        pl,
        pt,
        tr,
        ko,
        sv,
        hi,
        bn,
        sw
    },
    runtimeOnly: false,
})